require(`./styles.${process.env.PRODUCT}`);

